<template>
  <div>
    <!-- 轮播图 -->
    <div class="header">
      <div class="header-tag">About us</div>
      <div class="header-title">关于我们</div>
    </div>
    <div style="margin: 30px 0;">
      <div class="w">
        <div class="flex1">
          <div class="left">
            <img src="@/assets/img/关于我们配图-01.jpg" alt="">
          </div>
          <div class="right">
            <div> 
              <div class="titles">公司简介</div>
              <div class="sub-title">Profile</div>
            </div>
            <div class="content">
              <p>凡己科技（苏州）有限公司 是一家致力于中低压、大电流类电机控制器、智能仪表和智能终端等产品的研发、生产与销售的国家级高新技术企业。是中国工业车辆行业协会理事单位，江苏省专精特新中小企业，中国首个非道路电动控制器标准的主要起草单位。</p>
              <p>公司自2011年成立至今，始终专注于电控部件的研发，坚持以自主核心技术为客户服务，自主研发生产的电动车辆控制器、智能仪表、远程监控管理系统等系列产品，成功应用于电动叉车、电动仓储车、电动观光车、高尔夫球车、环卫车、高空作业平台、工程机械、农业、园林、船舶等领域。客户覆盖特雷克斯、中联重科、比亚迪叉车、合力集团、龙工、徐工集团等整车行业龙头企业，为非道路领域整机企业提供电动控制、智能、网联一站式解决方案。</p>
            </div>
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <div>
              <div class="titles">客户价值</div>
              <div class="sub-title">Customer Value</div>
            </div>
            <div class="content">
              <p>敏捷：对客户的应用需求做出快速响应</p>
              <!-- <p>Rapidly ：Quick response to customer requirements in numerous segmented fields</p> -->
              <p>精湛：安全可靠的产品、高效率的工艺质控</p>
              <p>专业：国际领先的核心技术和先进测试能力</p>
              <!-- <p>Advanced：Internationally leading technology and advanced testing capabilities</p> -->
              
              <!-- <p>Reliable：High quality products with efficient process of quality control</p> -->
            </div>
          </div>
          <div class="right">
            <img src="@/assets/img/关于我们配图-02.jpg" alt="">
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <img src="@/assets/img/关于我们配图-03.jpg" alt="">
          </div>
          <div class="right">
            <div>
              <div class="titles">企业愿景</div>
              <div class="sub-title">Vision</div>
            </div>
            <div class="content">
              <p>做非道路电驱动的世界级企业，为推动全球电动化的普及做出贡献。</p>
            </div>
          </div>
        </div>
        <div class="flex1">
          <div class="left">
            <div>
              <div class="titles">共同价值观</div>
              <div class="sub-title">Shared Value</div>
            </div>
            <div class="content">
              <p>客户-客户第一，服务至上；</p>
              <p>责任-勇于担当，拥抱变化；</p>
              <p>诚信-言而有信，兑现承诺；</p>
              <p>简单-坦诚沟通，高效行动。</p>
            </div>
          </div>
          <div class="right">
            <img src="@/assets/img/关于我们配图-04.jpg" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import Vue from 'vue'
export default {
    data() {
        return {
           
        }
    },
    methods: {
        
    },
    mounted() {
        debugger
        let vType= this.$route.query.type;
        if(vType!=null&&vType=="app"){
          this.$emit("hideHead");
        }
    }
}
</script>

<style scoped lang="scss">
.header {
  background: url('../../assets/img/aboutusbanner.jpg') no-repeat;
  background-size: 100% ;
}

.flex1 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 400px;
  margin-top: 30px;
}

.flex1 img {
  width: 100%;
  height: 400px;
}

.left {
  width: 48%;
}

.right {
  width: 48%;
}
.titles {
  font-size: 24px;
}
.sub-title {
  font-size: 20px;
  margin-top: 10px;
  color: #999;
}
.content {
  max-height: 400px;
  overflow: hidden;
}
.content p{
  margin-top: 10px;
  text-indent: 2rem;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/about/index.vue